/* Let's Mix — cart page: ajax quantity/remove/note with section re-render */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  var busy = false;

  function section() { return document.querySelector('[data-lm-cart]'); }

  function updateHeaderCount(cart) {
    var nodes = document.querySelectorAll('.cart-item-count-header--quantity, .cart-item-count-header, [data-cart-count]');
    nodes.forEach(function (n) { n.textContent = cart.item_count; });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart, bubbles: true }));
  }

  function sectionId() {
    var sec = section();
    return sec ? sec.getAttribute('data-section-id') : null;
  }

  function swap(html) {
    var sec = section();
    if (!sec || !html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('[data-lm-cart]');
    if (fresh && sec.parentNode) {
      fresh.querySelectorAll('.lm-reveal').forEach(function (el) { el.classList.add('is-in'); });
      sec.parentNode.replaceChild(fresh, sec);
      bind();
    }
  }

  /* Section Rendering API — no JSON Accept header, or /cart answers with cart.js data */
  function rerender() {
    var id = sectionId();
    if (!id) return Promise.resolve();
    return fetch(root + 'cart?sections=' + encodeURIComponent(id))
      .then(function (r) { return r.json(); })
      .then(function (json) { swap(json[id]); });
  }

  function setBusy(state) {
    busy = state;
    var sec = section();
    if (sec) sec.classList.toggle('is-busy', state);
  }

  function change(line, quantity) {
    if (busy) return;
    setBusy(true);
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: [sectionId()], sections_url: root + 'cart' })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateHeaderCount(cart);
        if (cart.sections && cart.sections[sectionId()]) { swap(cart.sections[sectionId()]); return; }
        return rerender();
      })
      .catch(function () { window.location.reload(); })
      .then(function () { setBusy(false); });
  }

  var noteTimer;
  function saveNote(value) {
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: value })
      });
    }, 500);
  }

  function bind() {
    var sec = section();
    if (!sec || sec.__lmBound) return;
    sec.__lmBound = true;

    sec.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-lm-qty-minus]');
      var plus = e.target.closest('[data-lm-qty-plus]');
      var remove = e.target.closest('[data-lm-remove]');
      var lineEl = e.target.closest('[data-lm-line]');
      if (!lineEl) return;
      var line = parseInt(lineEl.getAttribute('data-lm-line'), 10);
      var input = lineEl.querySelector('[data-lm-qty-input]');
      if (minus) { e.preventDefault(); change(line, Math.max(0, parseInt(input.value, 10) - 1)); }
      else if (plus) { e.preventDefault(); change(line, parseInt(input.value, 10) + 1); }
      else if (remove) { e.preventDefault(); lineEl.classList.add('is-removing'); change(line, 0); }
    });

    sec.addEventListener('change', function (e) {
      var input = e.target.closest('[data-lm-qty-input]');
      if (input) {
        var lineEl = input.closest('[data-lm-line]');
        var q = parseInt(input.value, 10);
        if (isNaN(q) || q < 0) q = 0;
        change(parseInt(lineEl.getAttribute('data-lm-line'), 10), q);
      }
    });

    sec.addEventListener('input', function (e) {
      var note = e.target.closest('[data-lm-note]');
      if (note) saveNote(note.value);
    });
  }

  /* Quick add elsewhere on the page (LM · Product range) → refresh the cart */
  document.addEventListener('lm:cart:added', function () { rerender(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
})();
